$(function() {
    $('body').on('click', '.go-to', function (event) {
        var top = $('.' + $(this).data('go-to-class')).eq(0).offset().top;

        $('body, html').animate({ scrollTop: top - 40 }, animateSpeed, 'linear');
    });


    $('.js-close-free-lesson-container').on('click', function(event) {
        setCookie('free_lesson', 'false', { 'expires' : 30, 'path' : '/' });
        $('.free-lesson-container').empty().remove();
        const closeFreeLessonEvent = new CustomEvent('closeFreeLesson');
        document.dispatchEvent(closeFreeLessonEvent);
    });


    $('body').on('click', '.delete-learner', function(event) {
        ajaxProfileDeleteLearner($(this).parents('.learner-container').data('learner-id'));
    });
});